import React from "react";
import "./App.css";
import MatchStick from "./MatchStick";

function App() {
  return (
    <div className="App">
      <MatchStick />
    </div>
  );
}

export default App;
